import React from 'react';

const Footer = () => {

    return (
        <React.Fragment>
            <div className="dnw-footer">
                <div className="dnw-footer-l">
                    <div className="dnw-footer-r">
                        <div className="dnw-footer-body">
                            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                <tbody>
                                <tr>
                                    <td>
                                        <div><p>
                                            &nbsp;</p>
                                            <table border="0" style={{width: "100%"}}>
                                                <tbody>
                                                <tr>
                                                    <td style={{textAlign: "center", hieght: '50px'}}>
                                                        <p>
                                                                <span style={{color: "rgb(128,128,128)"}}>
                                                                    <span style={{fontFamily: 'times new roman'}}>
                                                                        <span><strong>Hệ Thống Đại L&yacute; V&eacute; Số Kiến Thiết</strong></span>
                                                                    </span>
                                                                </span>
                                                            <span>
                                                                    <span style={{fontFamily: 'times new roman'}}>
                                                                        <span style={{fontSize: "15px"}}>
                                                                            <span style={{color: "rgb(128,0,0)"}}>
                                                                                <strong>MINH NGỌC<br/> </strong>
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                    <span style={{color: "rgb(128,128,128)"}}>Địa chỉ: 229-228 Ng&ocirc; Tất Tố,&nbsp;T 56, Bình Thạnh, TP. HCM, Việt Nam.
                                                                        <br/>
                                                                        &nbsp; Tel:<span
                                                                            style={{fontSize: "14px"}}><strong>028 430 7579 - 090 090 2422; </strong></span>
                                                                    </span>
                                                                    <br/>
                                                                <span style={{fontSize: "13px"}}>
                                                                    <span style={{color: "#808080"}}>
                                                                        <span style={{color: "#800000"}}>
                                                                            <strong><span
                                                                                style={{fontFamily: "Times New Roman"}}>ĐỔI V&Eacute; SỐ TR&Uacute;NG THƯỞNG</span></strong>
                                                                        </span>
                                                                    </span>
                                                                    <strong><span
                                                                        style={{color: "#808080"}}> Hotline: </span>
                                                                        <span
                                                                            style={{color: "#b22222"}}>097 083 8359</span>
                                                                    </strong>
                                                                </span>
                                                                </span>
                                                        </p>
                                                    </td>
                                                    <td height="50" style={{textAlign: "center"}}>
                                                        <p>
                                                                <span style={{color: 'rgb(128,128,128)'}}>
                                                                    <span style={{fontSize: '13px'}}><strong>C&ocirc;ng Ty TNHH MTV ĐẠI L&Yacute; XỔ SỐ MINH NGỌC</strong></span>
                                                                </span><br/>
                                                            <span style={{color: 'rgb(128,128,128)'}}>
                                                                    <span style={{fontSize: '14px'}}>
                                                                        <strong>
                                                                            <span>Minh Ngoc Lottery Agent Company Limited<br/>
                                                                            MST: 0284307579 - Tel: 0900902422 - 0970838359<br/>
                                                                            Dien Bien Phu Street, 23 Ward, Binh Thanh Dist, HCM City, Vietnam.
                                                                            </span>
                                                                        </strong>
                                                                    </span>
                                                                </span>
                                                        </p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div style={{textAlign: "center"}}>
                                                <a href="/"><br/>
                                                    Điều khoản sử dụng</a> | Li&ecirc;n
                                                hệ:&nbsp;info@minhngoc.website.vn
                                                | <a charSet="Xổ Số Minh Ngọc™" className="Xổ Số Minh Ngọc™"
                                                     href="/" id="Xổ Số Minh Ngọc™" name="Xổ Số Minh Ngọc™"
                                                     title="Xổ Số Minh Ngọc™"
                                                     type="Xổ Số Minh Ngọc™">www.minhngoc.website.vn</a></div>
                                            <p>
                                                &nbsp;</p>
                                            <div style={{textAlign: "center"}}>
                                                <a className="SE"
                                                   href="/"
                                                   jsname="RFGGw"
                                                >Xem tr&ecirc;n T&igrave;m
                                                    kiếm</a>&nbsp; |&nbsp;&nbsp;<a
                                                className="SE" href="/" jsname="yKrPze"
                                            >Xem tr&ecirc;n Google</a>&nbsp;|&nbsp;<a
                                                className="SE" href="/"
                                                jsname="yKrPze"
                                            >Chỉ đường đến XỔ SỐ MINH NGỌC ĐỔI SỐ
                                                TR&Uacute;NG</a>
                                            </div>
                                            <div style={{textAlign: "center"}}>
                                                &nbsp;
                                            </div>
                                            <div style={{textAlign: "center"}}>
                                                Copyright &copy; 1996 - Minh Ngọc&trade; All right
                                                Reserved<br/>
                                                &nbsp;
                                            </div>
                                            <div style={{textAlign: "center"}}>
                                                Tag: xs | xo so | xo so minh ngoc | xs minh ngoc | minhngoc |
                                                xsminhngoc | kqxs minh ngoc | xsmn | minh ngoc net | minhngoc.net.vn
                                                | minhngoc.website
                                                | minh ngoc com | xosominhngoc
                                            </div>
                                            <div style={{textAlign: "center"}}>
                                                &nbsp;
                                            </div>
                                            <div className="clear"/>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div className="dailog_bog"/>

                        </div>
                    </div>
                </div>
            </div>

            <script>

            </script>

        </React.Fragment>
    )
};

export default Footer;
